"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_ALL = 0;

exports.DISPLAY_MENU = function (id) {
  return "DISPLAY_" + id;
};